import { h } from 'preact'; /** @jsx h */

import SupportUsForm from '../../forms/SupportUsForm';
import CTABlock from '../components/roy/CTABlock/CTABlock';
import Content from '../components/roy/Content/Content';
import FixedCTA from '../components/roy/FixedCTA/FixedCTA';
import Heading from '../components/roy/Heading/Heading';
import Hero from '../components/roy/Hero/Hero';
import Image from '../components/roy/Image/Image';
import InlineCTA from '../components/roy/InlineCTA/InlineCTA';
import Paragraph from '../components/roy/Paragraph/Paragraph';
import ParallaxBanner from '../components/roy/ParallaxBanner/ParallaxBanner';
import ParallaxContent from '../components/roy/ParallaxBanner/ParallaxContent/ParallaxContent';
import Quote from '../components/roy/Quote/Quote';
import Section from '../components/roy/Section/Section';
import StickyCTA from '../components/roy/StickyCTA/StickyCTA';

import '../styles/roy/alt-er-pa-vei.scss';

const renderFromDone = id => {
    if (window.location.hash === '#' + id) {
        const elemtentWithForm = document.querySelector('#' + id);

        elemtentWithForm.scrollIntoView();
    }
};

const Roy = () => {
    return (
        <div className="roy">
            <Hero
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/hero-roy-2.jpg"
                alt="Roy ligger i sengen på sykehuset og får behandling."
            >
                <Heading type="h1" className="hero-title">
                    <span className="hero-title-section">
                        &quot;Luftambulanse, legebil, ambulanse og brannvesen -
                    </span>
                    <span className="hero-title-section">
                        <span>alt er på vei!</span>
                        &quot;
                    </span>
                </Heading>
            </Hero>

            <Section top color="off-black">
                <Content width="small">
                    <Paragraph type="ingress" color="all-white">
                        Roy Myking (63) skulle bare hvile litt på sofaen. Han hadde magesmerter,
                        kastet opp og følte seg ikke bra. Sekunder senere ser kona Sissel, pupillene
                        til Roy forsvinne. Hun får ikke lenger kontakt med han.
                    </Paragraph>
                    <Paragraph
                        type="byline"
                        textAndPhoto="Karoline Lervik Sandvold"
                        color="all-white"
                    />
                    <Paragraph type="normal" color="all-white">
                        Denne mandagen starter som alle andre. Barnebarna på 8 og 11 år er på besøk
                        etter skolen, og når Roy er tilbake fra jobb spiser de middag sammen, før
                        alle hviler litt. Etter hvert går Roy ut for å jobbe på bilen før guttene
                        drar på fotballtrening. Sissel blir igjen inne og holder på i huset. Omsider
                        kommer Roy inn. Han forteller kona at han har magesmerter. Ikke lenge etter
                        starter han å kaste opp.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - Vi hadde raspeballer til middag så jeg spurte om kanskje middagen hadde
                        vært litt tung. Jeg tenkte ikke at det kunne være noe alvorlig på det
                        tidspunktet, forteller Sissel.
                    </Quote>
                    <Paragraph color="all-white">
                        Roy er på badet en stund før han starter å gå frem og tilbake i huset.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - Da han tok seg en paracet tenkte jeg at nå er han faktisk ganske dårlig
                        for det gjør han aldri uten at det er høyst nødvendig, sier hun.
                    </Quote>
                    <Paragraph type="normal" color="all-white">
                        Han fortsetter å vandre frem og tilbake mellom stua og badet. Så begynner
                        han å kaldsvette. Sissel spør da: «Skal jeg ringe legen?»
                    </Paragraph>
                    <Paragraph type="background" color="all-white">
                        «Nei, det er ikke nødvendig. Dette går nok fort over», svarer Roy.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-1"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/tilkomst-til-pasient-LFT-21955-1.jpg"
                alt="Legehelikopter i solen med halepartiet i fokus."
                orientation="right"
                color="off-white"
                colorTop="off-black"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="right" color="transparent-white">
                    <Quote animation="fade-up" color="off-black" className="no-margin">
                        - Det siste minnet jeg har er at jeg gikk gjennom porten mot huset, og at
                        jeg begynte å føle meg dårlig.
                    </Quote>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <StickyCTA
                    title="Bli støttemedlem"
                    text="Din støtte går til livreddende innovasjon og utvikling - slik som videoløsningen brukt i denne saken."
                    buttonText="Bli støttemedlem"
                    link="#stott-oss"
                    orientation="left"
                    icon
                />
                <Content width="small">
                    <Heading>- Ah, der var det noe som slapp</Heading>
                    <Paragraph>
                        Klokken nærmer seg 21, og Sissel går på badet for å gjøre seg i stand for å
                        legge seg. Så hører hun en lyd fra stua. Hun går for å sjekke hva det kan
                        være. Roy står i døren og slår seg i brystet.{' '}
                        <i>«Ah, der var det noe som slapp!»</i>, sier Roy lettet.
                    </Paragraph>
                    <Paragraph>
                        Han vil hvile litt på sofaen, men i det han legger seg ned forsvinner
                        pupillene bakover. Sissel får ikke lenger kontakt med ham. Hun ringer
                        sønnen, Morten (38) som bor i underetasjen for å få hjelp.{' '}
                    </Paragraph>

                    <Quote animation="fade-up" color="secondary">
                        - Han tok ikke telefonen så da tenkte jeg «blås i han», jeg ringer 113.
                        <FixedCTA
                            color="snla-red"
                            text="<b>1 av 3</b><br /> ringer ikke<br /> 113 først."
                            buttonText="Last ned<br /><b>Hjelp 113</b>"
                            icon="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-app-icon.png"
                            link="/hjelp/"
                        />
                    </Quote>
                    <Paragraph>
                        Til AMK forteller Sissel hvem det gjelder og hva som har hendt. De sender
                        Sissel en link som hun blir bedt om å trykke på slik at de får tilgang til
                        kameraet hennes. De vil se Roy.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        - Videoløsningen var utrolig smart! I stedet for at jeg skulle prøve å
                        forklare hva jeg så, veiledet hun meg hele veien. Det var utrolig
                        betryggende.
                    </Quote>
                    <InlineCTA
                        type="accordion"
                        color="primary"
                        buttonText="<b>Bli støttemedlem</b> - Din støtte bidrar til å redde liv"
                        link="#stott-oss"
                    >
                        <details className="accordion">
                            <summary className="accordion-summary">
                                <Heading
                                    type="h4"
                                    color="all-black"
                                    weight="500"
                                    className="no-margin"
                                >
                                    Videoløsningen - Et livsviktig verktøy
                                </Heading>
                                <span className="material-symbols-outlined">
                                    keyboard_arrow_down
                                </span>
                            </summary>
                            <p>
                                Stiftelsen Norsk Luftambulanse har laget en videoløsning som gir
                                AMK- og legevakter muligheten til å opprette en videosamtale med
                                innringer. Denne løsningen gir operatøren et klarere bilde av
                                situasjonen og bidrar til at riktige ressurser kan bli sendt ut
                                raskere. Det bidrar til å redde liv.
                            </p>
                        </details>
                    </InlineCTA>
                    <Paragraph>
                        Sissel blir bedt om å hente en saks for å klippe opp genseren til Roy. Hun
                        får beskjed om å legge trykk på ulike steder, samtidig som de stiller
                        spørsmål om han er blå på magen.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        - Jeg gjorde som jeg fikk beskjed om. Jeg var ikke redd, men veldig
                        skjelven. Det føltes veldig dramatisk ut.
                    </Quote>
                    <Paragraph>
                        På dette tidspunktet føler Sissel at hun har gitt AMK all den informasjonen
                        hun kan gi, og hun venter bare på at AMK skal si at hjelpen er på vei.
                    </Paragraph>
                    <Paragraph type="background" color="secondary">
                        <i>
                            «Alt er på vei! Luftambulansen, legebil, ambulanse. Og brannvesenet
                            kommer snart. Jeg har trykket på knappen. Hjelpen er på vei!»
                        </i>
                        , bekrefter AMK.
                    </Paragraph>
                    <Paragraph>
                        Da føler Sissel at hun kan roe seg litt ned. Hun løper ned i underetasjen
                        for å hente sønnen sin mens hun roper: «Morten, Morten! Du må komme! Pappa
                        har fått hjerteinfarkt».
                    </Paragraph>
                    <Paragraph className="bold">
                        <b>
                            På dette tidspunktet vet ingen hva som feiler Roy. Det skal vise seg at
                            det er langt verre enn et hjerteinfarkt.
                        </b>
                    </Paragraph>
                    <Heading type="h3">Stua var full av folk</Heading>
                    <Paragraph>
                        Mens Morten ringer etter broren sin Roger (36) kommer de første fra
                        brannvesenet fra Manger. De er akutthjelpere og første respondere når
                        ambulansen er et stykke unna. Ikke lenge etter kommer legebil og ambulanse
                        også, før luftambulansen lander på et jorde nedenfor huset deres.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-2"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/roy-og-sissel-rundt-salongbordet-2.jpg"
                alt="Roy og Sissel sitter rundt salongbordet og snakker sammen."
                orientation="right"
                color="off-white"
                colorTop="off-white"
                colorBottom="off-black"
            >
                <ParallaxContent orientation="right">
                    <Quote animation="fade-up" color="primary-white" className="no-margin">
                        - Stua var full av leger, sykepleier og brannmenn, men alle var så rolige.
                        De var så profesjonelle, og utrolig flinke, smiler Sissel.
                    </Quote>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-black">
                <StickyCTA
                    title="Bli støttemedlem"
                    text="Din støtte går til livreddende innovasjon og utvikling - slik som videoløsningen brukt i denne saken."
                    buttonText="Bli støttemedlem"
                    link="#stott-oss"
                    orientation="left"
                    icon
                />
                <Content width="small">
                    <InlineCTA
                        type="accordion"
                        color="primary"
                        buttonText="<b>Bli støttemedlem</b> - Din støtte bidrar til å redde liv"
                        link="#stott-oss"
                    >
                        <details className="accordion">
                            <summary className="accordion-summary">
                                <Heading
                                    type="h4"
                                    color="all-black"
                                    weight="500"
                                    className="no-margin"
                                >
                                    Akutthjelperordningen er vinn-vinn for alle
                                </Heading>
                                <span className="material-symbols-outlined">
                                    keyboard_arrow_down
                                </span>
                            </summary>
                            <p>
                                Stiftelsen Norsk Luftambulanse har i 14 år kurset brannfolk over
                                hele landet i førstehjelp slik at de blir Akutthjelpere. De spiller
                                en avgjørende rolle da de ofte er raskere fremme hos pasienten enn
                                lege og ambulansepersonell. De er trent til å utføre grunnleggende
                                førstehjelp til helsepersonell kommer, og har vært med å redde mange
                                liv.
                            </p>
                        </details>
                    </InlineCTA>
                    <Paragraph color="all-white">
                        Det blir tatt EKG av Roy og helsepersonellet jobbet iherdig for å finne ut
                        hva som feiler ham. Sissel tror fortsatt på dette tidspunktet at Roy har et
                        hjerteinfarkt, men hører at de snakker om utposning.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - Etter en stund bar de ham ut i ambulansen og rygget ned til porten for å
                        deretter bære ham inn i legehelikopteret som fløy han til Haukeland.
                    </Quote>
                    <Paragraph color="all-white">
                        Sissel og barna hopper i bilen og kjører etter til sykehuset.
                    </Paragraph>
                    <Heading type="h3" color="all-white">
                        Et kritisk døgn
                    </Heading>
                    <Paragraph color="all-white">
                        Det tar ikke lang tid før kirurgen kommer for å prate med Sissel, deres tre
                        barn og Roy sin mor etter at de ankommer sykehuset.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - Kirurgen sa at det var veldig alvorlig. Man kan jo tenke seg at et
                        hjerteinfarkt er ille, men Roys tilstand var enda verre.
                    </Quote>
                    <Paragraph color="all-white">
                        En del av hovedpulsåren ned til magen har revnet helt og må erstattes. En
                        annen del har en stor utposing og det må settes inn en stent.
                    </Paragraph>
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjerte-roy.jpg"
                        alt="En illustrasjon som viser hvordan deler av hovedpulsåren til Roy ble revet av, mens en annen del hadde en utposning."
                        caption="For å forstå hva som hadde skjedd, fikk Sissel og familien denne illustrasjonen som viser hvordan deler av hovedpulsåren til Roy ble revet av, mens en annen del hadde en utposning."
                        captionColor="all-white"
                    />
                    <Quote animation="fade-up" color="primary-white">
                        - Vi ble fortalt at de hadde to av Haukelands beste kirurger på jobb, samt
                        at de hadde hentet inn den tredje. Han var i de beste hender.
                    </Quote>
                    <Paragraph color="all-white">
                        Roy blir tatt med inn på operasjonsbordet kl. 01.30. De er ikke ferdige før
                        kl. 11 neste formiddag. Roys tilstand er kritisk. Familien hans får beskjed
                        om at de ikke kan garantere noe som helst.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - Det er rart hvordan livet kan snu på et blunk. Vi var på fotballkamp med
                        barnebarna dagen før og hadde det kjempefint. På mandagen snudde alt, sier
                        Sissel.
                    </Quote>
                    <Paragraph color="all-white">
                        Roy klarer seg gjennom operasjonen, men må ligge på intensivavdelingen i 7
                        uker. Og som følge av det som har skjedd får Roy både nyresvikt og
                        lungebetennelse, og må ha dialyse. Det er noen tøffe uker for Roy og
                        familien.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        - På Haukeland sa de at det hadde vært helt avgjørende at Roy var i veldig
                        god fysisk form, og at luftambulansen kom.
                    </Quote>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-3"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/roy-paa-sykehuset.jpg"
                alt="Roy ligger i sengen på sykehuset med familien rundt seg."
                orientation="right"
                color="off-white"
                colorTop="off-black"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="left">
                    <Heading type="h3" color="all-white" className="no-margin">
                        Rehabilitering
                    </Heading>
                    <Paragraph color="all-white">
                        Etter 7 uker på Haukeland sykehus blir Roy sendt til Nordås på
                        rehabilitering.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white" className="no-margin">
                        - Da han reiste fra Haukeland klarte Roy så vidt å reise seg fra sengen, med
                        hjelp. Etter 8 uker på rehabilitering klarte han å gå ut selv, sier Sissel.
                    </Quote>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <Content width="small">
                    <Paragraph type="background" color="secondary" className="no-margin">
                        - Jeg var på 0, og måtte starte helt fra begynnelsen med både mat og
                        bevegelse, forteller Roy.
                    </Paragraph>
                    <Paragraph>
                        Han er fortsatt ikke 100%, men Roy har et håp om å kunne jobbe igjen. I dag
                        står det fortsatt en seng i stua så han kan hvile når han trenger det.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        - En slik hendelse får en til å se litt annerledes på ting. Han yngste
                        sønnen vår sier at vi må leve mens vi kan.
                    </Quote>
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/09/roy-i-godstolen-inline.jpg"
                        alt="Sissel og Roy fikk livet snudd på hodet denne mandagen. Roy er fortsatt ikke helt frisk, men jobber hver eneste dag for å bli bedre. "
                        caption="Sissel og Roy fikk livet snudd på hodet denne mandagen. Roy er fortsatt ikke helt frisk, men jobber hver eneste dag for å bli bedre. "
                    />
                    <Paragraph>
                        Før hendelsen var det Roy som hjalp Sissel med ting, men nå er det omvendt
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary" className="bold">
                        - Han sier: «Det er så mye styr med meg», men da sier jeg at jeg er så glad
                        for at jeg har dette styret. For alternativet hadde vært mye verre, smiler
                        Sissel.
                    </Quote>
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="small">
                    <div className="form-wrapper supportus-form-wrapper" id="stott-oss">
                        <SupportUsForm
                            id="support-us-999"
                            level={2}
                            renderCb={renderFromDone}
                            options={[
                                {
                                    value: 250,
                                    label: '250'
                                },
                                {
                                    value: 300,
                                    label: '300'
                                },
                                {
                                    value: 400,
                                    label: '400'
                                },
                                {
                                    value: 500,
                                    label: '500'
                                }
                            ]}
                        />
                    </div>
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="large">
                    <CTABlock
                        divider
                        color="secondary"
                        title="Det koster <b>ingenting</b> å være bedre forberedt"
                        innerTitle="Last ned Hjelp 113-appen"
                        buttonText="<b>Hjelp 113</b> - Last ned appen her"
                        link="/hjelp/"
                        orientation="left"
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-cta-bottom.jpg"
                        alt="Utviklingshelikopteret på øvelse"
                        bulletPoints={[
                            'Alle nødnumre på ett sted (110, 112 og 113)',
                            'Andre viktige numre som nærmeste legevakt og mental helse hjelpetelefon',
                            'Koordinatene der du befinner deg',
                            'Oversikt over hjertestartere i nærheten',
                            'Appen er gratis og har nå 2,6 millioner nedlastninger'
                        ]}
                    />
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="small"></Content>
            </Section>
        </div>
    );
};

export default Roy;
